"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Web3ServiceList =
/*#__PURE__*/
function () {
  function Web3ServiceList() {
    (0, _classCallCheck2.default)(this, Web3ServiceList);
    this._list = [];
  }

  (0, _createClass2.default)(Web3ServiceList, [{
    key: "push",
    value: function push(service) {
      //put a warning if this list is length 2 or more
      this._list.push(service);
    }
  }, {
    key: "disconnectAll",
    value: function disconnectAll() {
      var _this = this;

      return Promise.all(this._list, function (s) {
        return s.manager()._disconnect();
      }).then(function () {
        return _this._list = [];
      });
    }
  }]);
  return Web3ServiceList;
}(); // eslint-disable-next-line


var l = new Web3ServiceList();
var _default = l;
exports.default = _default;